import React, { useEffect, useState } from "react";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form } from "react-bootstrap";
function CollageRegistration_step_1({ register, errors, setValue }) {
  useEffect(() => {
    setValue("role_id", 3); //  STUDENT ROLE
  }, []);
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <h5 className="step-heading">A. Organization Account & Verification</h5>

      <div className="form_holder">
        <div className="row">
          <div className="col-md-12">
            <input type="hidden" {...register("role_id")} />
            <Form.Group className="mb-3">
              <Form.Label>School Name</Form.Label>
              <Form.Control
                placeholder="Enter School Name"
                {...register("name", {
                  required: "School Name is required",
                  maxLength: {
                    value: 100,
                    message: "School Name cannot exceed 100 characters",
                  },
                })}
              />
              {errors?.name && (
                <Form.Text className="text-danger">
                  {errors?.name?.message}
                </Form.Text>
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Website URL</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Website URL"
                {...register("website_url", {
                  required: "Website URL is required",
                })}
              />
              {errors?.website_url && (
                <Form.Text className="text-danger">
                  {errors?.website_url?.message}
                </Form.Text>
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Generic School Email</Form.Label>
              <Form.Control
                type="email"
                {...register("email", {
                  required: "Generic School Email is required",
                  pattern: {
                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                    message: "Invalid email address",
                  },
                })}
              />
              {errors?.email && (
                <Form.Text className="text-danger">
                  {errors.email.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          {/* Right Column */}
          <div className="col-md-12">
            <Form.Group className="mb-3">
              <Form.Label>School Phone Number</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter 10-digit Mobile Number"
                maxLength={10}
                {...register("contact_no", {
                  required: "Generic Phone Number is required",
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message: "Please enter a valid 10-digit phone number",
                  },
                })}
                isInvalid={!!errors?.contact_no} // ✅ show red border
              />
              <Form.Control.Feedback type="invalid">
                {errors?.contact_no?.message}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>HeadQuarter Address</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter HeadQuarter Address"
                {...register("headquarter_address", {
                  required: "HeadQuarter Address is required",
                })}
              />
              {errors?.headquarter_address && (
                <Form.Text className="text-danger">
                  {errors?.headquarter_address?.message}
                </Form.Text>
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Password</Form.Label>
              <div className="position-relative">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder="Enter Password"
                  {...register("password", {
                    required: "Password is required",
                    minLength: {
                      value: 8,
                      message: "Password must be at least 8 characters",
                    },
                  })}
                />
                <FontAwesomeIcon
                  icon={showPassword ? faEye : faEyeSlash}
                  onClick={togglePasswordVisibility}
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    color: "#666",
                    fontSize: "18px",
                    zIndex: 10,
                  }}
                  className="text-muted"
                />
              </div>
              {errors?.password && (
                <Form.Text className="text-danger">
                  {errors.password.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>
        </div>
      </div>
    </>
  );
}

export default CollageRegistration_step_1;
